/** Legacy bridge actions used by the iframe screen state. */
export const legacyAction = {
    /**
     * Resets the legacy screen state to its initial values.
     *
     * @returns Action that clears the legacy bridge state.
     */
    resetScreen: () => ({
        type: 'legacy/RESET_SCREEN',
    }) as const,
    /**
     * Updates the legacy iframe loading flag.
     *
     * @param value Whether the iframe is currently loading.
     *
     * @returns Action that stores the iframe loading flag.
     */
    setIframeLoading: (value: boolean) => ({
        type: 'legacy/SET_IS_IFRAME_LOADING',
        payload: {value},
    }) as const,
};

/** Action dispatched when the legacy screen should be reset. */
export type ResetScreenAction = ReturnType<typeof legacyAction.resetScreen>;
/** Action dispatched when the legacy iframe loading state changes. */
export type SetIframeLoadingAction = ReturnType<typeof legacyAction.setIframeLoading>;

/** Union of all legacy bridge actions handled by the reducer. */
export type LegacyAction =
    | ResetScreenAction
    | SetIframeLoadingAction
;
